import './App.css'
import Month from './month/Month'

function App() {
  return (
    <div className="App">
      <Month />      
    </div>
  );
}

export default App;
